export function isChrome() {
  return (
    /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
  );
}

export function isFirefox() {
  return (
    /Firefox/.test(navigator.userAgent) || typeof InstallTrigger !== 'undefined'
  );
}

export function isSafari() {
  return (
    /Safari/.test(navigator.userAgent) &&
    /Apple Computer/.test(navigator.vendor)
  );
}

export function isEdge() {
  return /Edge/.test(navigator.userAgent);
}

export function isIE() {
  return /MSIE/.test(navigator.userAgent);
}

/**
 * @example
 * isBlockTag('<p>This is a paragraph</p>'): true
 * isBlockTag('<span>This is inline text</span>'): false
 */
export function isBlockTag(content: string) {
  const tempContainer = document.createElement('div');
  tempContainer.innerHTML = content.trim();

  const firstChild = tempContainer.firstElementChild;

  if (!firstChild) return false;

  const blockTags = [
    'ADDRESS',
    'ARTICLE',
    'ASIDE',
    'BLOCKQUOTE',
    'DETAILS',
    'DIALOG',
    'DIV',
    'DL',
    'FIELDSET',
    'FIGCAPTION',
    'FIGURE',
    'FOOTER',
    'FORM',
    'H1',
    'H2',
    'H3',
    'H4',
    'H5',
    'H6',
    'HEADER',
    'HR',
    'LI',
    'MAIN',
    'NAV',
    'OL',
    'P',
    'PRE',
    'SECTION',
    'TABLE',
    'UL',
  ];

  return blockTags.includes(firstChild.nodeName);
}
